/* tslint:disable */

declare var Object: any;
export interface SFCompanyInterface {
  "id"?: number;
}

export class SFCompany implements SFCompanyInterface {
  "id": number;
  constructor(data?: SFCompanyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFCompany`.
   */
  public static getModelName() {
    return "SFCompany";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFCompany for dynamic purposes.
  **/
  public static factory(data: SFCompanyInterface): SFCompany{
    return new SFCompany(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFCompany',
      plural: 'SFCompany',
      path: 'SFCompany',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFCompany.ts